import { WIDGET_TAGS, WIDGET_DATA } from './keys'
const initialState = { data: [], }
export default function reducer(state = initialState, action) {

    switch (action.type) {


        case WIDGET_DATA: {
            return { ...state, data: action.payload }
        }

        case WIDGET_TAGS: {

            return { ...state, tags: action.payload }
        }

        default:
            return { ...state }
    }

}